import { differenceInCalendarDays, startOfDay } from "date-fns";

/** คิว won ค้างแปลง ≥ N วัน = stale (ตรงกับ document warning window) */
export const AWAITING_CONVERT_STALE_DAYS = 7;

export function isAwaitingConvert(input: {
  status: string;
  convertedEventId: string | null | undefined;
}): boolean {
  return input.status === "won" && !input.convertedEventId;
}

export function isAwaitingConvertStale(
  input: {
    status: string;
    convertedEventId: string | null | undefined;
    updatedAt: Date | string;
  },
  now: Date = new Date(),
): boolean {
  if (!isAwaitingConvert(input)) return false;
  const updated = startOfDay(new Date(input.updatedAt));
  const today = startOfDay(now);
  return differenceInCalendarDays(today, updated) >= AWAITING_CONVERT_STALE_DAYS;
}

/** เลื่อน endDate ตาม delta ของ eventDate เมื่อไม่ระบุวันจบใหม่ */
export function shiftEndDateByEventDelta(
  previousEventDate: Date,
  previousEndDate: Date | null,
  newEventDate: Date,
): Date | null {
  if (!previousEndDate) return null;
  const delta = newEventDate.getTime() - previousEventDate.getTime();
  return new Date(previousEndDate.getTime() + delta);
}

export function isSameCalendarDay(a: Date, b: Date): boolean {
  return (
    startOfDay(a).getTime() === startOfDay(b).getTime()
  );
}
